const searchs_params = {
  namespaced: true,
  state:{
    searchs_params_list:[],
  },
  mutations:{
    SET_searchs_params_list(state, val){
      state.searchs_params_list = val;
    },
  },
  actions:{
  },
  getters:{
  }
};


export default searchs_params;



// WEBPACK FOOTER //
// ./src/vuex/modules/searchs_params.js